/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Field_InvalidInputs */

const vi_error_shop_field_invalid = /** @type {(inputs: Error_Shop_Field_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị chưa hợp lệ.`)
};

/**

* @param {Error_Shop_Field_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_field_invalid = /** @type {((inputs?: Error_Shop_Field_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Field_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_field_invalid(inputs)
});